define('apps/course-intro/views/regions/nav',[
    'apps/course-intro/templates/regions/nav'
], function (template) {
    "use strict";

    return Mn.ItemView.extend({

        "tagName": 'menu',

        "template": template
    });
});

